class FacetFiltersFormSearch extends HTMLElement {
  constructor() {
    super();
    this.dimensionRangeTimer = null;
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');

    facetForm.addEventListener('input', (event) => {
      if (event.isDimensionRangeEvent) {
        event.stopImmediatePropagation();
        clearTimeout(this.dimensionRangeTimer);
        this.dimensionRangeTimer = setTimeout(() => {
          this.onDimensionRangeSubmit(event);
        }, 200);
        return;
      }
      this.debouncedOnSubmit(event);
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const btn = this.querySelector('.facet-filters .facet-filters__label');
    if (btn) {
      const elmOptions = this.querySelector('.facet-filters .select');
      btn.addEventListener('click', () => {
        elmOptions.classList.toggle('show');
      });
    }

    Array.from(document.querySelectorAll('.mobile-facets .mobile-facets__main .mobile-facets__details')).forEach(
      (element) => {
        let elmActiveOption = element.querySelectorAll('.mobile-facets__list input[type="checkbox"]:checked');
        if (elmActiveOption.length > 0) {
          if (element.querySelector('.count-active-option')) {
            element.querySelector('.count-active-option').classList.remove('hidden');
            element.querySelector('.count-active-option').textContent = '(' + elmActiveOption.length + ')';
          }
        } else {
          if (element.querySelector('.count-active-option')) {
            element.querySelector('.count-active-option').classList.add('hidden');
          }
        }

        if (element.querySelectorAll('.mobile-facets__list input[type="checkbox"]').length == 1) {
          element.classList.add('one-option');
        } else {
          element.classList.remove('one-option');
        }
      }
    );

    if (document.querySelectorAll('.mobile-facets .mobile-facets__list input[type="checkbox"]:checked').length > 0) {
      if (document.querySelector('.mobile-facets .drawer-link-clear')) {
        document.querySelector('.mobile-facets .drawer-link-clear').classList.add('option-active');
      }
    } else {
      if (document.querySelector('.mobile-facets .drawer-link-clear')) {
        document.querySelector('.mobile-facets .drawer-link-clear').classList.remove('option-active');
      }
    }

    this.onHandleParamsFilter();
  }

  onHandleParamsFilter() {
    const queryString = window.location.search;
    if (queryString) {
      document.querySelector('.mobile-facets__footer--bottom .mobile-facets__clear-wrapper').style.color = '#3A3631';
    } else {
      document.querySelector('.mobile-facets__footer--bottom .mobile-facets__clear-wrapper').style.color = '#AEA69A';
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersFormSearch.searchParamsInitial;
      if (searchParams === FacetFiltersFormSearch.searchParamsPrev) return;
      FacetFiltersFormSearch.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersFormSearch.searchParamsPrev = searchParams;
    const sections = FacetFiltersFormSearch.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    // document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.origin}/search?type=product&section_id=${section.section}&${searchParams}&view=ajax`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersFormSearch.filterData.some(filterDataUrl)
        ? FacetFiltersFormSearch.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersFormSearch.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersFormSearch.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersFormSearch.filterData = [...FacetFiltersFormSearch.filterData, { html, url }];
        FacetFiltersFormSearch.renderFilters(html, event);
        FacetFiltersFormSearch.renderProductGridContainer(html);
        FacetFiltersFormSearch.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersFormSearch.filterData.find(filterDataUrl).html;
    FacetFiltersFormSearch.renderFilters(html, event);
    FacetFiltersFormSearch.renderProductGridContainer(html);
    FacetFiltersFormSearch.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    // document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
    //   .parseFromString(html, 'text/html')
    //   .getElementById('ProductGridContainer').innerHTML;

    // document
    //   .getElementById('ProductGridContainer')
    //   .querySelectorAll('.scroll-trigger')
    //   .forEach((element) => {
    //     element.classList.add('scroll-trigger--cancel');
    //   });

    const resultsContainer = document.getElementById('predictive-search-results');

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const btnLoadMore = document.getElementById('predictive__loadmore');
    const newProducts = doc.querySelectorAll('.rocket-card-search');
    const newLoadMoreBtn = doc.querySelector('.loadMoresearch');
    resultsContainer.innerHTML = '';
    newProducts.forEach((product) => {
      resultsContainer.appendChild(product.cloneNode(true));
    });
    btnLoadMore.innerHTML = '';
    if (newLoadMoreBtn) {
      btnLoadMore.appendChild(newLoadMoreBtn.cloneNode(true));
    }
  }

  static renderProductCount(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const count_doc = doc.querySelector('.mobile-facets__count');
    if (count_doc) {
      const count = count_doc.innerHTML;
      const container = document.getElementById('number_results_mobile');
      const containerDesktop = document.getElementById('number_results');
      const countFilter = document.querySelector('.filter-search .filter-drawer-count');
      console.log(countFilter);
      if (containerDesktop) {
        container.innerHTML = count;
        containerDesktop.innerHTML = count;
        countFilter.innerHTML = `(${count})`;
      }
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersFormSearch.renderActiveFacets(parsedHTML);
    FacetFiltersFormSearch.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersFormSearch.renderCounts(countsToRender, event.target.closest('.js-filter'));

    const btn = document.querySelector('.facet-filters .facet-filters__label');
    if (btn) {
      const elmOptions = document.querySelector('.facet-filters .select');
      const labelElement = document.querySelector('.facet-filters__label--name');

      btn.addEventListener('click', () => {
        elmOptions.classList.toggle('show');
        if (elmOptions.classList.contains('show')) {
          labelElement.style.display = 'none';
        } else {
          labelElement.style.display = '';
        }
      });
    }

    Array.from(document.querySelectorAll('.mobile-facets .mobile-facets__main .mobile-facets__details')).forEach(
      (element) => {
        let elmActiveOption = element.querySelectorAll('.mobile-facets__list input[type="checkbox"]:checked');
        if (elmActiveOption.length > 0) {
          if (element.querySelector('.count-active-option')) {
            element.querySelector('.count-active-option').classList.remove('hidden');
            element.querySelector('.count-active-option').textContent = '(' + elmActiveOption.length + ')';
          }
        } else {
          if (element.querySelector('.count-active-option')) {
            element.querySelector('.count-active-option').classList.add('hidden');
          }
        }
      }
    );

    if (document.querySelectorAll('.mobile-facets .mobile-facets__list input[type="checkbox"]:checked').length > 0) {
      if (document.querySelector('.mobile-facets .drawer-link-clear')) {
        document.querySelector('.mobile-facets .drawer-link-clear').classList.add('option-active');
      }
    } else {
      if (document.querySelector('.mobile-facets .drawer-link-clear')) {
        document.querySelector('.mobile-facets .drawer-link-clear').classList.remove('option-active');
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersFormSearch.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // Array.from(document.querySelectorAll('.number_results')).forEach(section => {
    //   section.textContent = '(' + html.getElementById('filter-count').textContent.replace('(', '').replace(')', '').trim() + ')'
    // })
    // const number = document.getElementById("number_results");
    // const numberMb = document.getElementById("number_results_mobile");

    const queryString = window.location.search;
    if (queryString) {
      document.querySelector('.mobile-facets__footer .mobile-facets__clear-wrapper').style.color = '#3A3631';
    } else {
      document.querySelector('.mobile-facets__footer .mobile-facets__clear-wrapper').style.color = '#AEA69A';
    }

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    // history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('predictive-search-results').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    const newSearchParams = `/search?${searchParams}&view=ajax`;
    FacetFiltersFormSearch.renderPage(newSearchParams, event);
  }

  onDimensionRangeSubmit(event) {
    event.preventDefault();
    const form = event.target.closest('form');

    const sourceFilter = event.sourceFilter;

    const searchParams = this.createSearchParams(form);
    this.onSubmitForm(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form-search form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersFormSearch.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersFormSearch.renderPage(url);
  }
}

FacetFiltersFormSearch.filterData = [];
FacetFiltersFormSearch.searchParamsInitial = window.location.search.slice(1);
FacetFiltersFormSearch.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form-search', FacetFiltersFormSearch);
FacetFiltersFormSearch.setListeners();
class PriceRangeSearch extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();

    this.querySelectorAll('.range-wrap').forEach((wrap) => {
      const range = wrap.querySelector('.range');
      const bubble = wrap.querySelector('.bubble');

      range.addEventListener('input', () => {
        this.setBubble(range, bubble);
      });
      this.setBubble(range, bubble);
    });

    this.handleCustomChangeInput();
  }

  onRangeChange(event) {
    // this.adjustToValidValues(event.currentTarget);
    // this.setBubble(event.currentTarget, bubble);
    this.setMinAndMaxValues();
  }

  setBubble(range, bubble) {
    const dataSymbol = this.getAttribute('data-symbol');
    const val = range.value;
    // const min = range.min ? range.min : 0;
    // const max = range.max ? range.max : 0;
    // const newVal = Number(((val - min) * 100) / (max - min));

    bubble.innerHTML = `${val}${dataSymbol}`;
    // Sorta magic numbers based on size of the native UI thumb
    // bubble.style.left = `calc(${newVal}% + (${-5 - newVal * 0.15}px))`;
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    // Set default min and max values to 0 if not present
    if (!minInput.value) minInput.value = '';
    if (!maxInput.value) maxInput.value = '';

    // Update min and max attributes based on the other input's value
    // if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    // if (minInput.value) maxInput.setAttribute('min', minInput.value);
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  handleCustomChangeInput() {
    try {
      const rangeInput = document.querySelectorAll('.range-input input'),
        priceInput = document.querySelectorAll('.price-input input'),
        range = document.querySelector('.slider .progress');

      let priceGap = 0;

      priceInput.forEach((input) => {
        input.addEventListener('input', (e) => {
          let minPrice = parseInt(priceInput[0].value),
            maxPrice = parseInt(priceInput[1].value);
          if (maxPrice - minPrice >= priceGap && maxPrice <= rangeInput[1].max) {
            if (e.target.className === 'input-min') {
              rangeInput[0].value = minPrice;
              range.style.left = (minPrice / rangeInput[0].max) * 100 + '%';
            } else {
              rangeInput[1].value = maxPrice;
              range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + '%';
            }
          }
        });
      });

      rangeInput.forEach((input) => {
        input.addEventListener('input', (e) => {
          let minVal = parseInt(rangeInput[0].value),
            maxVal = parseInt(rangeInput[1].value);
          const dataSymbol = document.querySelector('price-range').getAttribute('data-symbol');

          if (maxVal - minVal < priceGap) {
            if (e.target.className === 'range-min') {
              rangeInput[0].value = maxVal - priceGap;
            } else {
              rangeInput[1].value = minVal + priceGap;
            }
          } else {
            priceInput[0].value = minVal;
            priceInput[1].value = maxVal;
            range.style.left = (minVal / rangeInput[0].max) * 100 + '%';
            range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + '%';
          }

          document.querySelector('.label-min-price').textContent = minVal + dataSymbol;
          document.querySelector('.label-max-price').textContent = maxVal + dataSymbol;
        });
      });
    } catch (error) {
      console.error('Error: ', error);
    }
  }
}

customElements.define('price-range-search', PriceRangeSearch);

function handleTriggerCloseFilter() {
  const btnClose = document.querySelector('.btn-close-filter');
  if (!btnClose) return;

  btnClose.addEventListener('click', function () {
    document.querySelector('.mobile-facets__close').click();
  });
}

handleTriggerCloseFilter();

function rangeMinValFunc(rangeVal) {
  const rangeMinWidth = (document.querySelector('.range-wrap.min .bubble').textContent = rangeVal);
  document.querySelector('.range-wrap.min .bubble').textContent = rangeVal + '€';
  // const rangeMaxWidth = document.querySelector('.range-wrap.max .bubble').textContent = rangeVal

  document.querySelector('.range-wrap.min .bubble').style.left = 'calc(' + rangeMinWidth + '%)';
  // document.querySelector('.range-wrap.max .bubble').style.left = "calc("+rangeMaxWidth+"% - 8px)"
}

function rangeMaxValFunc(rangeVal) {
  // const rangeMinWidth = document.querySelector('.range-wrap.min .bubble').textContent = rangeVal
  const rangeMaxWidth = (document.querySelector('.range-wrap.max .bubble').textContent = rangeVal);
  document.querySelector('.range-wrap.max .bubble').textContent = rangeVal + '€';

  // document.querySelector('.range-wrap.min .bubble').style.left = "calc("+rangeMinWidth+"% - 8px)"
  document.querySelector('.range-wrap.max .bubble').style.left = 'calc(' + rangeMaxWidth + '%)';
}

class MedidasDimensionRange extends HTMLElement {
  static globalSubmitTimer = null;
  static activeElement = null;

  constructor() {
    super();
    this.isMobile = this.dataset.mobile === 'true';
    this.filterParam = this.dataset.filterParam;
    this.filterValues = this.dataset.filterValues
      ? this.dataset.filterValues.split(',').map((v) => parseInt(v.trim()))
      : [];
    this.filterCounts = this.dataset.filterCounts
      ? this.dataset.filterCounts.split(',').map((v) => parseInt(v.trim()))
      : [];
    this.activeValues = this.dataset.filterActive
      ? this.dataset.filterActive.split(',').map((v) => parseInt(v.trim()))
      : [];

    this.minValue = parseInt(this.dataset.minValue);
    this.maxValue = parseInt(this.dataset.maxValue);
    this.currentMin = parseInt(this.dataset.currentMin);
    this.currentMax = parseInt(this.dataset.currentMax);

    this.debounceTimer = null;
    this.isModifying = false;

    this.storageKey = `medidas_range_${this.filterParam}`;

    this.init();
  }

  init() {
    this.correctInitialRange();

    this.setupElements();
    this.setupEventListeners();
    this.updateProgressBar();
    this.updateHiddenInputs();

    if (!window.medidasDimensionComponents) {
      window.medidasDimensionComponents = new Map();
    }
    window.medidasDimensionComponents.set(this.filterParam, this);
  }

  correctInitialRange() {
    const savedRange = this.getSavedRange();

    if (savedRange) {
      this.currentMin = savedRange.min;
      this.currentMax = savedRange.max;
    } else {
      this.currentMin = this.minValue;
      this.currentMax = this.maxValue;
    }

    this.dataset.currentMin = this.currentMin.toString();
    this.dataset.currentMax = this.currentMax.toString();
  }

  setupElements() {
    const prefix = this.isMobile ? 'mobile-medidas-dimension-range' : 'medidas-dimension-range';

    this.minInput = this.querySelector(`.${prefix}-input-group input[data-type="min"]`);
    this.maxInput = this.querySelector(`.${prefix}-input-group input[data-type="max"]`);
    this.minRange = this.querySelector(`.${prefix}-sliders .range-min`);
    this.maxRange = this.querySelector(`.${prefix}-sliders .range-max`);
    this.progressBar = this.querySelector(`.${prefix}-sliders .range-progress`);
    this.hiddenInputsContainer = this.querySelector('.hidden-inputs');
    this.rangeContainer = this.querySelector('.mobile-medidas-dimension-range-inputs');

    if (!this.minInput) {
      this.minInput = this.querySelector('input[type="number"]:first-of-type');
    }
    if (!this.maxInput) {
      this.maxInput = this.querySelector('input[type="number"]:last-of-type');
    }
    if (!this.minRange) {
      this.minRange = this.querySelector('input[type="range"].range-min');
    }
    if (!this.maxRange) {
      this.maxRange = this.querySelector('input[type="range"].range-max');
    }
    if (!this.progressBar) {
      this.progressBar = this.querySelector('.range-progress');
    }

    // Simple: Update elements with current values
    if (this.minInput) {
      this.minInput.value = this.currentMin;
      this.minInput.setAttribute('min', '0');
    }
    if (this.maxInput) {
      this.maxInput.value = this.currentMax;
      this.maxInput.setAttribute('min', '0');
    }
    if (this.minRange) {
      this.minRange.value = this.currentMin;
      this.minRange.setAttribute('min', '0');
    }
    if (this.maxRange) {
      this.maxRange.value = this.currentMax;
      this.maxRange.setAttribute('min', '0');
    }
  }
  setupEventListeners() {
    if (this.minInput) {
      this.minInput.addEventListener('input', (e) => this.handleNumberInput(e, 'min'));
    }
    if (this.maxInput) {
      this.maxInput.addEventListener('input', (e) => this.handleNumberInput(e, 'max'));
    }

    if (this.minRange) {
      this.minRange.addEventListener('input', (e) => this.handleRangeInput(e, 'min'));
      this.minRange.addEventListener('mousedown', (e) => e.stopPropagation());
    }
    if (this.maxRange) {
      this.maxRange.addEventListener('input', (e) => this.handleRangeInput(e, 'max'));
      this.maxRange.addEventListener('mousedown', (e) => e.stopPropagation());
    }
  }

  syncAllElements() {
    if (this.minInput && this.minInput.value != this.currentMin) {
      this.minInput.value = this.currentMin;
    }
    if (this.maxInput && this.maxInput.value != this.currentMax) {
      this.maxInput.value = this.currentMax;
    }
    if (this.minRange && this.minRange.value != this.currentMin) {
      this.minRange.value = this.currentMin;
    }
    if (this.maxRange && this.maxRange.value != this.currentMax) {
      this.maxRange.value = this.currentMax;
    }
  }

  handleNumberInput(event, type) {
    const value = parseInt(event.target.value) || 0;

    this.isModifying = true;
    MedidasDimensionRange.activeElement = this;

    if (type === 'min') {
      let newMin = Math.max(this.minValue, Math.min(value, this.maxValue));
      if (newMin > this.currentMax) {
        this.currentMax = newMin;
      }

      this.currentMin = newMin;
    } else {
      let newMax = Math.min(this.maxValue, Math.max(value, this.minValue));

      if (newMax < this.currentMin) {
        this.currentMin = newMax;
      }

      this.currentMax = newMax;
    }

    this.syncAllElements();

    if (this.isAtFullRange()) {
      this.clearSavedRange();
    } else {
      this.saveRange(this.currentMin, this.currentMax);
    }

    this.debouncedUpdate();
  }

  handleRangeInput(event, type) {
    const value = parseInt(event.target.value) || 0;

    this.isModifying = true;
    MedidasDimensionRange.activeElement = this;

    if (type === 'min') {
      let newMin = Math.max(this.minValue, Math.min(value, this.maxValue));
      if (newMin > this.currentMax) {
        this.currentMax = newMin;
      }

      this.currentMin = newMin;
    } else {
      let newMax = Math.min(this.maxValue, Math.max(value, this.minValue));
      if (newMax < this.currentMin) {
        this.currentMin = newMax;
      }

      this.currentMax = newMax;
    }

    this.syncAllElements();
    if (this.isAtFullRange()) {
      this.clearSavedRange();
    } else {
      this.saveRange(this.currentMin, this.currentMax);
    }

    this.debouncedUpdate();
  }

  debouncedUpdate() {
    this.updateProgressBar();
    this.updateHiddenInputs();

    if (this.isModifying && MedidasDimensionRange.activeElement === this) {
      this.submitForm();
    }

    setTimeout(() => {
      this.isModifying = false;
      if (MedidasDimensionRange.activeElement === this) {
        MedidasDimensionRange.activeElement = null;
      }
    }, 100);
  }

  updateProgressBar() {
    if (!this.progressBar) return;

    const range = this.maxValue - this.minValue;
    const leftPercent = ((this.currentMin - this.minValue) / range) * 100;
    const rightPercent = ((this.maxValue - this.currentMax) / range) * 100;

    this.progressBar.style.left = leftPercent + '%';
    this.progressBar.style.right = rightPercent + '%';

    if (this.rangeContainer) {
      this.rangeContainer.style.setProperty('--left', `${leftPercent}%`);
      this.rangeContainer.style.setProperty('--right', `${rightPercent}%`);
    }
  }

  updateHiddenInputs() {
    if (!this.hiddenInputsContainer) return;

    const existingInputs = this.hiddenInputsContainer.querySelectorAll(`input[name="${this.filterParam}"]`);
    existingInputs.forEach((input) => input.remove());

    if (this.isAtFullRange()) {
      this.clearSavedRange();
      return;
    }

    const valuesInRange = this.filterValues.filter((value) => value >= this.currentMin && value <= this.currentMax);

    if (valuesInRange.length > 0) {
      valuesInRange.forEach((value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = this.filterParam;
        input.value = value;
        input.setAttribute('data-dimension-filter', this.filterParam);
        this.hiddenInputsContainer.appendChild(input);
      });
    } else {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = this.filterParam;
      input.value = this.currentMax;
      input.setAttribute('data-dimension-filter', this.filterParam);
      this.hiddenInputsContainer.appendChild(input);
    }
  }

  submitForm() {
    const isFullRange = this.isAtFullRange();

    if (isFullRange) {
      console.log(`[${this.filterParam}] 🗑️ Submitting form to REMOVE filter (full range detected)`);
    } else {
      this.saveRange(this.currentMin, this.currentMax);
    }

    clearTimeout(MedidasDimensionRange.globalSubmitTimer);
    MedidasDimensionRange.globalSubmitTimer = setTimeout(() => {
      const form = this.closest('form');
      if (form && this.isModifying) {
        const event = new Event('input', { bubbles: true });
        event.isDimensionRangeEvent = true;
        event.sourceFilter = this.filterParam;
        event.isFilterRemoval = isFullRange;
        form.dispatchEvent(event);
      }
    }, 100);
  }
  forceSyncWithSaved() {
    const savedRange = this.getSavedRange();
    if (savedRange) {
      this.currentMin = savedRange.min;
      this.currentMax = savedRange.max;

      this.dataset.currentMin = this.currentMin.toString();
      this.dataset.currentMax = this.currentMax.toString();

      if (this.minInput) {
        this.minInput.value = this.currentMin;
      }
      if (this.maxInput) {
        this.maxInput.value = this.currentMax;
      }
      if (this.minRange) {
        this.minRange.value = this.currentMin;
      }
      if (this.maxRange) {
        this.maxRange.value = this.currentMax;
      }

      this.updateProgressBar();
      this.updateHiddenInputs();

      return true;
    }
    return false;
  }

  saveRange(min, max) {
    try {
      const rangeData = { min, max, timestamp: Date.now() };
      localStorage.setItem(this.storageKey, JSON.stringify(rangeData));
    } catch (e) {
      console.warn('Could not save range to localStorage:', e);
    }
  }

  getSavedRange() {
    try {
      const saved = localStorage.getItem(this.storageKey);
      if (saved) {
        const rangeData = JSON.parse(saved);
        const isRecent = Date.now() - rangeData.timestamp < 3600000;
        if (isRecent && rangeData.min !== undefined && rangeData.max !== undefined) {
          return { min: rangeData.min, max: rangeData.max };
        }
      }
    } catch (e) {
      console.warn('Could not load range from localStorage:', e);
    }
    return null;
  }

  clearSavedRange() {
    try {
      localStorage.removeItem(this.storageKey);
    } catch (e) {
      console.warn('Could not clear range from localStorage:', e);
    }
  }

  disconnectedCallback() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  }

  static clearAllSavedRanges() {
    try {
      const keysToRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('medidas_range_')) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach((key) => localStorage.removeItem(key));
    } catch (e) {
      console.warn('Could not clear saved ranges:', e);
    }
  }

  static hasActiveDimensionFilters() {
    try {
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('medidas_range_')) {
          const saved = localStorage.getItem(key);
          if (saved) {
            const rangeData = JSON.parse(saved);
            const component = document.querySelector(
              `medidas-dimension-range[data-filter-param="${key.replace('medidas_range_', '')}"]`
            );
            if (component) {
              const minValue = parseInt(component.dataset.minValue);
              const maxValue = parseInt(component.dataset.maxValue);
              if (rangeData.min !== minValue || rangeData.max !== maxValue) {
                return true;
              }
            }
          }
        }
      }
    } catch (e) {
      console.warn('Could not check active dimension filters:', e);
    }
    return false;
  }

  isAtFullRange() {
    return this.currentMin === this.minValue && this.currentMax === this.maxValue;
  }
}

customElements.define('medidas-dimension-range', MedidasDimensionRange);

class FacetRemoveSearch extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();

    const link = event.currentTarget;
    const href = link.getAttribute('href');

    if (href && (href.includes('?') === false || href === window.location.pathname)) {
      MedidasDimensionRange.clearAllSavedRanges();
    }

    const form = this.closest('facet-filters-form-search') || document.querySelector('facet-filters-form-search');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove-search', FacetRemoveSearch);
